import { RouteObject } from 'react-router-dom';
import { CreatePartyPage, ProcessPartyCasePage } from './lazy';

export const PARTY_ROOT = '/party';

export const PARTY_ROUTES = {
  registration: `${PARTY_ROOT}/registration`,
  createParty: `${PARTY_ROOT}/create-account`,
  processPartyCase: `${PARTY_ROOT}/process-details`,
};

export const partyRouteObject: RouteObject = {
  path: PARTY_ROOT,
  children: [
    {
      path: PARTY_ROUTES.createParty,
      element: <CreatePartyPage />,
    },
    {
      path: `${PARTY_ROUTES.processPartyCase}`,
      element: <ProcessPartyCasePage />,
    },
  ],
};
